<template>
    <div class="d-flex">
        <div v-if="info.passengerQuantity" class="mr-3 text-body-2">
            <v-icon :size="xSmall ? 'x-small' : small ? 'small' : null">mdi-account</v-icon>
            {{ info.passengerQuantity }}
        </div>
        <div v-if="info.doorCount" class="mr-3 text-body-2">
            <v-icon :size="xSmall ? 'x-small' : small ? 'small' : null">mdi-car-door</v-icon>
            {{ info.doorCount }}
        </div>
        <div v-if="info.baggageQuantity" class="mr-3 text-body-2">
            <v-icon :size="xSmall ? 'x-small' : small ? 'small' : null">mdi-bag-checked</v-icon>
            {{ info.baggageQuantity }}
        </div>
        <div v-if="info.airConditioning" class="text-body-2">
            <v-icon :size="xSmall ? 'x-small' : small ? 'small' : null"> mdi-snowflake </v-icon>
            {{ $t('carsRent.air_conditioning') }}
        </div>
    </div>
</template>

<script lang="ts">
    import {Vue, Component, Prop} from 'vue-facing-decorator'

    @Component
    export class CarCharacteristic extends Vue {
        @Prop({type: Object, required: true}) info
        @Prop({default: () => false, type: Boolean}) small
        @Prop({default: () => false, type: Boolean}) xSmall
    }

    export default CarCharacteristic
</script>
